import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useTenant } from '../context/TenantContext';
import PrivacyPolicyIcon from '../assets/images/icons/privacy-policy-outline.svg';
import DOMPurify from 'dompurify';

const ServicePolicy = () => {
  const { t } = useLanguage();
  const { tenant } = useTenant();

  // Add CSS for links in service policy content
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .service-policy-content a {
        color: #2563eb !important;
        text-decoration: underline !important;
        cursor: pointer !important;
      }
      .service-policy-content a:hover {
        color: #1d4ed8 !important;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <div className="max-w-5xl mx-auto p-4 md:p-8 md:px-4 space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <img src={PrivacyPolicyIcon} alt="Privacy Policy" className="w-6 h-6" />
        <h1 className="text-base font-extrabold text-theme-secondary">
          {tenant?.tenantservicepolicydisplay || t('servicePolicy.title') || 'Service Privacy Policy'}
        </h1>
      </div>

      {/* Service Policy Content */}
      <div className="text-gray-700">
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(tenant?.tenantservicepolicy || ''),
          }}
          className="service-policy-content"
          style={{
            color: '#374151',
            textAlign: 'left',
          }}
        />
      </div>
    </div>
  );
};

export default ServicePolicy;
